import React, { useEffect } from 'react'
import { alertRef } from '../../../../App';
import Dropdown from '../../../../Components/Dropdown/Dropdown';
import Stepper from '../../../../Components/Stepper/Stepper';
import { Button, Input, Textarea } from '../../../../Components/StyledComponents';
import { convertCost, onlyNum } from '../../../../Utils/functions';
import './CreateOptionGroup.scss';

const CreateOptionGroup = ({createOptionGroup}) => {
    const [ step, setStep ] = React.useState(1)
    const [ name, setName ] = React.useState('')
    const [ desc, setDesc ] = React.useState('')
    const [ options, setOptions ] = React.useState([{ Name : '', Price : 0 , Description : '' }])
    const [ isRequire, setIsRequire ] = React.useState(true)
    const [ selectableCount, setSelectableCount ] = React.useState({ Min : 1, Max : 1 })

    useEffect(() => {
        let arr = selectableCount;
        if( isRequire ) arr.Min = 1;
        else arr.Min = 0
        setSelectableCount(arr)
    },[isRequire])

    const handleOptionName = (val,i) => {
        let arr = options;

        options[i].Name = val;

        setOptions([...arr])
    }

    const handleOptionPrice = (val,i) => {
        let arr = options;

        options[i].Price = val;

        setOptions([...arr])
    }

    const handleOptionDescription = (val,i) => {
        let arr = options;

        options[i].Description = val;

        setOptions([...arr])
    }

    const removeOption = (i) => {
        let arr = options;

        arr.splice(i,1);

        setOptions([...arr])
    }

    const addOption = () => {
        if( options.length > 0 && options[options.length - 1].Name === '' ){
            alertRef.current.showAlert({ title : '이전 항목을 입력해주세요.', subTitle : '', isCancel : true, cancelText : '닫기', isConfirm : false})
            return
        }
        setOptions(old => [...old,{ Name : '', Price : 0, Description : '' }])
    }

    const nextStep = () => {
        if(step !== 4) setStep(old => old+1)
        else post()
    }

    const getOptions = () => {
        let arr = []

        for(let i=0; i<options.length; i++){
            arr.push({ key : i+1 + '개', value : i+1 })
        }

        return arr;
    }

    const post = () => {
        let arr = [];
        for(let i=0; i<options.length;i++){
            arr.push({ Name : options[i].Name, Price : parseInt(options[i].Price), Description : options[i].Description })
        }
        createOptionGroup({
            Name : name,
            Description : desc,
            Options : arr,
            isRequire : isRequire,
            SelectableCount : {
                Min : parseInt(selectableCount.Min),
                Max : parseInt(selectableCount.Max)
            }
        })
    }

    const isDisabled = () => {
        if(step === 1 && name.trim() === '' ) return true
        else if( step === 2 && ( options.length === 0 || options[0].Name.trim() === '' )) return true
        else return false
    }

    return (
        <div className='create-option-group'>
            <Stepper maxStep={4} step={step} containerStyle={{ marginBottom : step === 4 ? 0 : 40 }}/>
            {
                step === 4 && <p className="warn-text">모두 입력되었어요. 마지막으로 확인해주세요.</p>
            }
            {
                step === 1 &&
                <>
                    <div className='row'>
                        <p className='label'>옵션그룹명</p>
                        <Input
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            style={{ width : 347 }}
                            placeholder="예) 맛선택, 사이드메뉴 추가 등"
                        />
                    </div>

                    <div className='row' style={{ alignItems : 'flex-start', marginTop : 16 }}>
                        <p className='label'>설명(선택)</p>
                        <Textarea
                            value={desc}
                            onChange={(e) => setDesc(e.target.value)}
                            style={{ width : 347, height : 173 }}
                            placeholder="예) 추가 옵션입니다 (1개 이상 필수)"
                        />
                    </div>
                </>
            }

            {
                step === 2 &&
                <>
                    <p className='label'>옵션정보</p>
                    {
                        options.map((data,i) => {
                            return (
                                <div key={i}>
                                    <div className="row" key={i}>
                                        <Input value={data.Name} onChange={(e) => handleOptionName(e.target.value,i)} placeholder="예) 1인분, 300g 등" style={{ width : 180, marginRight : 16 }}/>
                                        <label htmlFor={`price${i}`} data-domain="원">
                                            <Input htmlFor={`price${i}`} value={data.Price} onChange={(e) => handleOptionPrice(onlyNum(e.target.value),i)} placeholder="0" style={{ width : 180 }}/>
                                        </label>
                                        <Button variant="sub" onClick={()=> removeOption(i)} style={{ width : 28, height : 28, borderRadius : 100, boxSizing : 'border-box', padding : 0, marginLeft : 16 }}>
                                            -
                                        </Button>
                                    </div>
                                    <Input htmlFor={`price${i}`} value={data.Description} onChange={(e) => handleOptionDescription(e.target.value,i)} placeholder="옵션에 대한 설명을 입력해주세요." style={{ width : 376, marginTop : 8 }}/>
                                    {
                                        i < (options.length - 1) && <div className='divider' style={{ marginTop : 24, marginBottom : 24 }}></div>
                                    }
                                </div>           
                            )
                        })
                    }
                    <Button variant="sub" small onClick={() => addOption()} style={{ width : 113, marginTop : 16 }}>
                        <div className='row'>
                            <img src={require('../../../../aseets/icons/plus_pink.svg').default} style={{ width : 24, height : 24, marginRight : 8 }} />
                            추가하기
                        </div>
                    </Button>
                </>
            }

            {
                step === 3 &&
                <>
                    <p className='label'>옵션정보</p>
                    <div className='row' style={{ marginTop : 16 }}>
                        <button className={`${ isRequire ? 'selected-btn' : 'unselected-btn'}`} style={{ marginRight : 32, width : 180 }} onClick={() => setIsRequire(true)}>
                            <div className='row' style={{ justifyContent : 'center' }}>
                                {
                                    isRequire ?
                                    <img src={require('../../../../aseets/icons/check.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                                    :
                                    <img src={require('../../../../aseets/icons/check_white.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                                }
                                옵션 선택시 주문가능
                            </div>
                        </button>

                        <button className={`${ !isRequire ? 'selected-btn' : 'unselected-btn'}`} style={{ width : 232 }} onClick={() => setIsRequire(false)}>
                            <div className='row' style={{ justifyContent : 'center' }}>
                                {
                                    isRequire ?
                                    <img src={require('../../../../aseets/icons/close.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                                    :
                                    <img src={require('../../../../aseets/icons/close_white.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                                }
                                옵션 선택하지 않아도 주문가능
                            </div>
                        </button>
                    </div>

                    <p className='label' style={{ marginTop : 40 }}>옵션 개수</p>
                    <p className='label' style={{ marginTop : 8, marginBottom : 16, opacity : 0.5, width : 'fit-content' }}>현재 옵션 그룹에는 {options.length}개의 옵션이 있어요.</p>
                    <div className='row'>
                        {
                            isRequire &&
                            <>
                                <p className='drop-text'>최소</p>
                                <Dropdown
                                    width={161}
                                    options={getOptions()}
                                    onItemClick={(val) => setSelectableCount({...selectableCount, Min : val})}
                                    selected={true}
                                    value={selectableCount.Min}
                                    btnStyle={{ marginRight : 16 }}
                                    prefix={'개'}
                                />
                            </>
                        }
                        <p className='drop-text'>최대</p>
                        <Dropdown
                            width={isRequire ? 161:379}
                            options={getOptions()}
                            onItemClick={(val) => setSelectableCount({...selectableCount, Max : val})}
                            selected={true}
                            value={selectableCount.Max}
                            prefix={'개'}
                        />
                    </div>
                </>
            }
            
            {
                step === 4 &&
                <>
                    <p className="label" style={{ marginTop : 16 }}>옵션 그룹명</p>
                    <p className="text">{name}</p>
                    <div className="divider" style={{ margin : 0 }} />

                    <p className="label" style={{ marginTop : 16 }}>설명</p>
                    {
                        desc === '' ?
                        <p className="text-none">등록된 내용이 없어요.</p>
                        :
                        <p className="text">{desc}</p>
                    }
                    <div className="divider" style={{ margin : 0 }} />

                    <p className="label" style={{ marginTop : 16 }}>옵션</p>
                    {
                        options.map((data,i) => {
                            return(
                                <div key={i}>
                                    <p className="text">{data.Name} : {convertCost(data.Price)}원</p>
                                    {
                                        data.Description !== '' &&
                                        <p className="text-desc">옵션 설명 : {data.Description}</p>
                                    }
                                </div>
                            )
                        })
                    }
                    <div className="divider" style={{ margin : 0 }} />

                    <p className="label" style={{ marginTop : 16 }}>옵션 개수</p>
                    <p className="text">{isRequire ? `최소 ${selectableCount.Min}개 ` : ''} 최대 {selectableCount.Max}개</p>
                </>
            }
            

            <div className='btn-row'>
                {
                    step !== 1 &&
                    <Button variant="outline" className='save-btn' fontSize={16} onClick={() => setStep(old => old -1)} style={{ marginRight : 24 }}>
                        이전
                    </Button>
                }
                <Button variant="main" className='save-btn' fontSize={16} onClick={() => nextStep()} disabled={isDisabled()}>
                    {step === 4 ? '추가하기' : '다음'}
                </Button>
            </div>
        </div>
    )
}

export default CreateOptionGroup;